import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ReminderPropertyDialog(props) {
  const [open] = React.useState(true);
  return (
    <div>
      <Dialog
        open={open}
        onClose={props.handleReminderClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Property Address and City already exist. Do you still want to continue? 
         Press Ok </DialogTitle>        
        <DialogActions>
          <Button onClick={props.handleReminderClose} color="primary">
            Cancel
          </Button>
          <Button onClick={props.handleReminderAccept} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
